export const LegalTransactionRelationshipRoleEnum = {
  Buyer: 1,
  Seller: 2,
  BuildingManager: 3,
  Inheritor: 4,
  Testator: 5,
  Spouse: 6,
  FamilyMember: 7,
  Child: 8,
  NonFamilyInheritor: 9,
  Parent: 10,
  Company: 11,
  Participant: 12,
  Beneficiary: 13,
  Shareholder: 14,
  ManagingDirector: 15,
  AuthorizedSignatory: 16, // Prokurist
  ConcreteRepresentation: 17, // "konkrete Vertretung" GbR
  OtherParticipant: 18,
  ContactPerson: 19,
  Signer: 20,
  Tenant: 21,
} as const;

export type LegalTransactionRelationshipRoleEnum =
  (typeof LegalTransactionRelationshipRoleEnum)[keyof typeof LegalTransactionRelationshipRoleEnum];
